import '@polymer/iron-icon/iron-icon';
import '../../../../neb-styles/neb-styles';
import '../../../../neb-styles/neb-icons';

import { html } from '@polymer/polymer/polymer-element';

import { NebLayoutMedia } from '../../../../neb-app-layout/neb-layout-media';

class NebNavItem extends NebLayoutMedia {
  static get template() {
    return html`
      <style include="neb-styles">
        :host {
          display: flex;
          flex: 1;
        }

        .nav-label {
          flex: 1;
          font-weight: normal;
        }

        .arrow {
          justify-content: flex-end;
          transform: scaleX(-1);
          width: 10px;
          height: 15px;
          margin-right: 4px;
          color: var(--neb-font-color-secondary);
        }

        :host([layout-small]) .nav-label {
          font-weight: bold;
        }
      </style>

      ${super.template}

      <span id="navLabel" class="nav-label">[[label]]</span>
      <iron-icon
        id="navIcon"
        class="arrow"
        icon="neb:back"
        hidden$="[[!layoutSmall]]"
      ></iron-icon>
    `;
  }

  static get properties() {
    return {
      label: String,
      selected: {
        type: Boolean,
        reflectToAttribute: true,
      },
    };
  }
}
customElements.define('neb-nav-item', NebNavItem);
